<template>
  <div>
    
      <el-carousel ref="carousel" trigger="click"  arrow="never" :indicator-position="''" :autoplay='true' :interval='10000' :height="height">
        <el-carousel-item>
          <iframe :height="height" frameborder="none" width="100%" :src="`${baseUrl}/#/template_01`"></iframe>
        </el-carousel-item>
        <el-carousel-item>
          <iframe :height="height" frameborder="none" width="100%" :src="`${baseUrl}/#/oil`"></iframe>
        </el-carousel-item>
        <el-carousel-item>
          <iframe :height="height" frameborder="none" width="100%" :src="`${baseUrl}/#/lng`"></iframe>
        </el-carousel-item>
        <el-carousel-item>
          <iframe :height="height" frameborder="none" width="100%" :src="`${baseUrl}/#/newEnergy`"></iframe>
        </el-carousel-item>
      </el-carousel>
      <div style="height: 75px; width: 100%; position: absolute; top:0; left:0;background: rgba(0,0,0,0);z-index: 100;"></div>
  </div>
</template>

<script>

export default {
  components: {},
  name: 'Screen',
  data() {
    return {
      baseUrl:window.location.href.split('#')[0]
    }
  },
  computed:{
    height(){
      
        return this.$root.docHeight+'px'

    }
  },
  methods:{

    // 滑动切换
	slideBanner() {
    //选中的轮播图
    var box = document.querySelector('.el-carousel__container');
    var startPoint = 0;
    var stopPoint = 0;
    //重置坐标
    var resetPoint = function () {
      startPoint = 0;
      stopPoint = 0;
    }
    //手指按下
    box.addEventListener("touchstart", function (e) {
      //手指点击位置的X坐标
      startPoint = e.changedTouches[0].pageX;
    });
    //手指滑动
    box.addEventListener("touchmove", function (e) {
      //手指滑动后终点位置X的坐标
      stopPoint = e.changedTouches[0].pageX;
    });
    //当手指抬起的时候，判断图片滚动离左右的距离
    let that = this
    box.addEventListener("touchend", function () {
      if (stopPoint == 0 || startPoint - stopPoint == 0) {
        resetPoint();
        return;
      }
      if (startPoint - stopPoint > 0) {
        resetPoint();
        that.$refs.carousel.next();
        return;
      }
      if (startPoint - stopPoint < 0) {
        resetPoint();
        that.$refs.carousel.prev();
        return;
      }
    });
  },

  },
  created(){
   
  },
  mounted(){
    this.$nextTick(()=>{
      // this.$refs.carousel.handleMouseEnter = () => { };//走马灯Carousel取消鼠标悬停不自动切换
      this.slideBanner()
    })
  },
  destroyed(){

  },
  watch: {
    
   
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  

</style>
